import { createSignal, onMount } from 'solid-js'
import { Router, A } from '@solidjs/router'
import { Portal } from 'solid-js/web'
import { ChevronDownOutline, PersonOutline, LogoutOutline, KeyOutline, GridOutline, PeopleOutline } from '@/icons'
import { res2json } from '@/utils'
import { store, setStore } from '@/store'
import Toast, { addToast } from '@/components/Toast'
import messenger from '@/store/messenger'
import account, { keepalive } from '@/store/account'
import Dashboard from '@/pages/Dashboard'
import Agents from '@/pages/Agents'
import StatisticsDailyBets from '@/pages/statistics/DailyBets'

const routes = [
  { path: '/', component: () => (document.location.href = '/home') },
  { path: '/home', component: Dashboard },
  { path: '/agents', component: Agents },
  { path: '/statistics/daily-bets', component: StatisticsDailyBets },
  { path: '*', component: NotFound }
]

export default function App() {
  return <Router root={Root}>{routes}</Router>
}

function NotFound() {
  return <div>页面不存在</div>;
}

function Root({ children }) {
  const [drawerOn, setDrawerOn] = createSignal(false)

  onMount(() => {
    messenger.listen(account())

    fetch(`/api/score`).then(res2json).then(r => setStore('score', r.data?.score ?? 0))

    setTimeout(() => keepalive(), 60_000)
  })

  async function logout() {
    return fetch('/api/logout').finally(() => {
      document.location.reload()
    })
  }

  let elMain
  const historyPushState = history.pushState
  history.pushState = function () {
    historyPushState.apply(this, arguments)
    elMain?.scrollTo(0, 0)
  }

  return (
    <>
      <div class="drawer">
        <input id="side-drawer-menu" type="checkbox" onChange={e => setDrawerOn(e.target.checked)} checked={drawerOn()} class="drawer-toggle" />
        <div class="drawer-content fixed inset-0 flex flex-col">
          <header class="flex-none">
            <div class="navbar bg-base-100">
              <div class="flex-1">
                <div class="flex-none lg:hidden">
                  <label for="side-drawer-menu" class="btn btn-square swap swap-rotate drawer-button">
                    <input type="checkbox" />
                    <svg class="swap-off fill-current" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 512 512"><path d="M64,384H448V341.33H64Zm0-106.67H448V234.67H64ZM64,128v42.67H448V128Z" /></svg>
                    <svg class="swap-on fill-current" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 512 512"><polygon points="400 145.49 366.51 112 256 222.51 145.49 112 112 145.49 222.51 256 112 366.51 145.49 400 256 289.49 366.51 400 400 366.51 289.49 256 400 145.49" /></svg>
                  </label>
                </div>
                <h1 class="ml-2 lg:ml-0 text-xl">永神总代后台{import.meta.env.MODE === 'staging' && <>(STG)</>}</h1>
              </div>
              <div class="flex-none"><span class="text-xs">剩{store.score}天</span></div>
              <div class="flex-none">
                <div class="dropdown dropdown-end dropdown-hover">
                  <div tabindex="0" role="button" class="btn btn-ghost"><span class="w-4"><PersonOutline /></span>{/*account().nickname*/}<span class="w-3"><ChevronDownOutline /></span></div>
                  <ul tabindex="0" class="dropdown-content menu bg-base-100 rounded-box z-[1] w-52 p-2 shadow">
                    <li><a role="button" onClick={() => window.editPassword.showModal()}><span class="w-5"><KeyOutline /></span>修改密码</a></li>
                    <li class="divider-1"></li>
                    <li><a role="button" onClick={() => logout()}><span class="w-5"><LogoutOutline /></span>退出登陆</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </header>
          <div class="flex-1 flex">
            <aside class="flex-none w-48 hidden lg:block relative">
              <div class="absolute w-full h-full overflow-y-auto no-scrollbar">
                <ul class="menu gap-1">
                  <li><A href="/home"><span class="w-5"><GridOutline /></span>后台首页</A></li>
                  <li><A href="/agents"><span class="w-5"><PeopleOutline /></span>代理列表</A></li>
                </ul>
                <h2 class="menu-title">统计报表</h2>
                <ul class="menu gap-1">
                  <li><A href="/statistics/daily-bets">每日投注统计</A></li>
                </ul>
              </div>
            </aside>
            <main class="flex-1 relative">
              <div ref={elMain} class="absolute w-full h-full px-4 lg:pl-16 overflow-y-auto">
                {children}
                <div class="h-4"></div>
              </div>
            </main>
          </div>
          <Toast />
        </div>

        <div class="drawer-side">
          <label for="side-drawer-menu" aria-label="close sidebar" class="drawer-overlay"></label>
          <div class="bg-base-200 text-base-content min-h-full w-80">
            <div class="py-8 flex items-center justify-center bg-base-300"><h1 class="text-xl">总代后台</h1></div>
            <ul class="menu p-4 gap-1">
              <li><A href="/home" onClick={() => setDrawerOn(false)}><span class="w-5"><GridOutline /></span>后台首页</A></li>
              <li><A href="/agents" onClick={() => setDrawerOn(false)}><span class="w-5"><PeopleOutline /></span>代理列表</A></li>
            </ul>
            <h2 class="menu-title">统计报表</h2>
            <ul class="menu p-4 gap-1">
              <li><A href="/statistics/daily-bets" onClick={() => setDrawerOn(false)}>每日投注统计</A></li>
            </ul>
          </div>
        </div>
      </div>

      <Portal mount={document.body}>
        <EditPasswordDialog />
      </Portal>
    </>
  )
}

function EditPasswordDialog() {
  const [oldPassword, setOldPassword] = createSignal('')
  const [password, setPassword] = createSignal('')
  const [confirmPassword, setConfirmPassword] = createSignal('')
  // const [otp, setOtp] = createSignal('')

  const [sending, setSending] = createSignal(false)
  const [errors, setErrors] = createSignal({})

  let elFocus

  onMount(() => {
    new MutationObserver((e) => {
      if (e[0].target.open) {
        setOldPassword('')
        setPassword('')
        setConfirmPassword('')
        // setOtp('')

        setErrors({})
        elFocus.focus()
      }
    }).observe(window.editPassword, { attributes: true })
  })

  async function submit(e) {
    e.preventDefault()
    if (sending()) {
      return
    }

    setSending(true)
    return fetch('/api/password', {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        old_password: oldPassword(),
        password: password(),
        confirm_password: confirmPassword(),
        // otp: otp()
      })
    }).then(res2json).then(r => {
      if (r.status >= 400) {
        setErrors(r.data)
      } else {
        addToast({ message: '密码已修改成功' })
        window.editPassword.close()
      }
    }).finally(() => { setSending(false) })
  }

  function cancel() {
    window.editPassword.close()
  }

  return (
    <dialog id="editPassword" class="modal">
      <form onSubmit={submit} class="modal-box flex flex-col gap-4">
        <button type="button" onClick={() => cancel()} class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2" disabled={sending()}>✕</button>
        <h3 class="text-lg">修改密码</h3>
        <div class="form-control">
          <div class="label"><span class="label-text">旧登陆密码</span></div>
          <input ref={elFocus} type="password" value={oldPassword()} onChange={e => setOldPassword(e.target.value)} class="input input-bordered" placeholder="请输入旧的登陆密码" required />
          {errors().old_password && (<div class="label"><span class="label-text-alt text-error">{errors().old_password}</span></div>)}
        </div>
        <div class="form-control">
          <div class="label"><span class="label-text">新登陆密码</span></div>
          <input type="password" value={password()} onChange={e => setPassword(e.target.value)} class="input input-bordered" placeholder="请输入新的登陆密码" required />
          {errors().password && (<div class="label"><span class="label-text-alt text-error">{errors().password}</span></div>)}
        </div>
        <div class="form-control">
          <div class="label"><span class="label-text">确认新登陆密码</span></div>
          <input type="password" value={confirmPassword()} onChange={e => setConfirmPassword(e.target.value)} class="input input-bordered" placeholder="请确认新的登陆密码" required />
          {errors().confirm_password && (<div class="label"><span class="label-text-alt text-error">{errors().confirm_password}</span></div>)}
        </div>
        {/* <div class="form-control">
          <div class="label"><span class="label-text">OTP</span></div>
          <input type="number" value={otp()} onChange={e => setOtp(e.target.value)} class="input input-bordered no-spin" required />
          {errors().otp && (<div class="label"><span class="label-text-alt text-error">{errors().otp}</span></div>)}
        </div> */}
        {errors().default && (<div class="text-error">{errors().default}</div>)}
        <div class="modal-action flex gap-4">
          <button type="button" onClick={() => cancel()} class="btn px-8" disabled={sending()}>取消</button>
          <button type="submit" class="btn btn-success text-white px-8" disabled={sending()}>确定</button>
        </div>
      </form>
    </dialog>
  )
}
